import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  input: {
    flexGrow: 1,
    '& fieldset': {
      backgroundColor: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      borderRadius: 3,
      minHeight: 45
    },

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing()
    },

    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    }
  },
  combo: {
    width: '100%',

    '& > div > label': {
      transform: 'translate(14px, 10px) scale(1)'
    },
    '& > div > div': {
      paddingBottom: `0 !important`,
      paddingTop: `0 !important`,
      paddingLeft: `${theme.spacing()} !important`,
      paddingRight: `${theme.spacing()} !important`
    },
    '& > div > div > div': {
      zIndex: 2
    },
    '& svg': {
      color: theme.palette.primary.main
    },

    [theme.breakpoints.up('md')]: {
      width: 350
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('md')]: {
      padding: 0
    }
  },
  addNumberLink: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    alignSelf: 'flex-start'
  },
  saveButton: {
    borderRadius: 10,
    width: 250,
    alignSelf: 'center',

    '& span': {
      color: theme.palette.primary.main,
      fontWeight: 500
    },

    '&:disabled': {
      backgroundColor: theme.palette.alt.light,

      '& span': {
        color: theme.palette.primary.contrastText
      }
    },

    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  option: {
    width: '100%',
    height: '100%',
    border: `1px solid ${theme.palette.primary.main}`,

    '&:hover': {
      backgroundColor: theme.utils.rgba(theme.palette.secondary.main, 0.6)
    }
  },
  optionLabel: {
    color: theme.palette.secondary.contrastText,

    '&:hover': {
      color: theme.palette.primary.main
    },

    '&.alert': {
      color: `${theme.palette.error.main} !important`
    }
  },
  optionAlert: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(),
    gap: theme.spacing(),

    '& p': {
      fontSize: '.875rem',
      fontWeight: 500
    }
  },
  formGroup: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 'auto'
    }
  },
  iconContainer: {
    alignSelf: 'center',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    padding: theme.spacing(1.5)
  },
  icon: {
    width: 61,
    height: 61
  },
  number: {
    fontWeight: 600,
    fontSize: '2rem'
  },
  fullName: {
    fontSize: '1.5rem',
    fontWeight: 500
  },
  inscriptionInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  distanceAndCategory: {
    fontSize: '1.5rem',
    fontWeight: 500
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  }
}))
